import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import index from '@/components/index'
import mapList from '@/components/mapList'
import componentList from '@/components/componentList'
import makeMap from '@/components/makeMap'
import userMange from '@/components/userMange'
import warn from '@/components/warn'
import system from '@/components/system'

Vue.use(Router)

export default new Router({
  // mode:"history",
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {path:"/makeMap",name:"makeMap",component:makeMap},
    {
      path: '/index',
      name: 'index',
      component: index,
      children:[
        {path:"mapList",name:"mapList",component:mapList},
        {path:"componentList",name:"componentList",component:componentList},
      
        {path:"userMange",name:"userMange",component:userMange},
        {path:"warn",name:"warn",component:warn},
        {path:"system",name:"system",component:system},
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js